<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="重新入库"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <div class="tips">
          <p>确定对入库失败的 eSIM 进行重新入库吗？</p>
          <p>此操作会产生一条新的入库批量操作</p>
          <p>确定后，相关记录请在「eSIM资源入库」-「入库记录」中查看</p>
        </div>
        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { reImportEsimInventories } from '@/api/esim_inventory'

export default {
  name: 'BatchOperationRecordEsimsReImport',
  props: {
    visible: { type: Boolean, required: true },
    batchOperationRecordId: { type: Number, required: true }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 're_import_esim_inventories' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        reImportEsimInventories({
          ...values,
          batch_operation_record_id: this.batchOperationRecordId
        }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>操作成功，具体结果请至 【eSIM资源入库】-【入库记录】 查看</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tips { padding: 0 77px; }
</style>
